var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex relative"},[_c('left-bar'),_c('div',{staticClass:"content w-full mx-12 main-content min-h-screen pt-12"},[_c('FeatureNav'),_c('router-view')],1),_c('ProfileNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }